declare global {
  // tslint:disable-next-line: interface-name
  interface Window {
    dataLayer: any;
  }
}

export enum UPSELL_COMPONENT_EVENT_NAME {
  'feature-upgrade' = 'feature_upsell_view',
  'general-upgrade' = 'general_upsell_view',
  'devices-upgrade' = 'devices_upsell_view',
  'freemium-upgrade' = 'freemium_upsell_view',
}

// TODO: update args
export function pushUpsellViewGTMEvent(eventName: string, id: string): void {
  if ( window.dataLayer ) {
    window.dataLayer.push( {
      event: eventName,
      upsell_id: id,
    } );
  }
}